module.exports = {"title":"About me","layout":"page","path":"/about","body":"<p>I’m a Fullstack Developer from Lyon, France. I love music, new technologies, web development, entrepreneurship, gifs and cats !</p>\n<p>I have worked for startups for 3 years, building websites, web applications, and search engines allowing me to increasd my technical skills.</p>\n<p>I’ve now decided to try freelancing while working during my free time on a personal project : <a href=\"http://Occaz.io\">Occaz.io</a></p>\n<img src=\"https://i.giphy.com/3o7qDSOvfaCO9b3MlO.gif\" width=\"500\" height=\"500\" />\n"}


//////////////////
// WEBPACK FOOTER
// ./pages/about/index.md
// module id = 517
// module chunks = 0